<template>
<span class="incomeStatistics-title">
    <div class="bj">
        <img src="/static/images/svolt/incomeStatistics.png" />
    </div>
    <div class="content">
        <span class="left">
            <slot>{{title}}</slot>
        </span>
    </div>
</span>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data() {
        return {
            title: ''
        }
    },
    methods: {},
    mounted() {}
}
</script>

<style lang="scss" scoped>
.incomeStatistics-title {
    position: relative;
    top: 0;
    left: 0;
    width: 400px;
    height: 20px;
    line-height: 30px;
    display: inline-block;

    .bj {
        position: absolute;
        top: 5px;
        left: 30px;
        width: 105%;
        height: 20vh;
        // z-index: 1;

        img {
            width: 420px;
            height: 100%;
        }
    }

    .content {
        position: absolute;
        top: 0px;
        left: 30px;
        z-index: 10;
        color: #0B0B3D;

        .left {
            font-size: 20px;
            font-family: pmzd;
            display: inline-block;
            line-height: 20px;
            margin-left: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/incomeStatistics-title.vue